import type { JSX } from 'react';

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import type { SxProps, Theme } from '@mui/material/styles';

import { checkIfIsArray } from '@e-socna/utils';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@e-socna/empty';

import { useUiContext } from '../../contexts/UiContext/hooks/useUiContext.hook';

import { DRAWER_WIDTH } from '../constants';

interface Props {
  readonly variant: 'loggedIn' | 'loggedOff';
  readonly children?: JSX.Element | readonly JSX.Element[];
  readonly sx?: SxProps<Theme>;
}

export const MainContent = ({
  variant,
  children,
  sx = EMPTY_ARRAY,
}: Readonly<Props>): JSX.Element => {
  const {
    ui: { isDataGridVisible },
  } = useUiContext();

  return (
    <Box
      component="main"
      sx={[
        {
          maxWidth: '100%',
          flexGrow: 1,
          p: 3,
          display: 'flex',
          minHeight: '100vh',
          ...(isDataGridVisible
            ? {
                maxHeight: '100vh',
              }
            : EMPTY_OBJECT),
          flexDirection: 'column',
          width:
            variant === 'loggedIn'
              ? { sm: `calc(100% - ${DRAWER_WIDTH.toFixed(2)}px)` }
              : EMPTY_OBJECT,
        },
        ...(checkIfIsArray(sx) ? sx : [sx]),
      ]}
    >
      {variant === 'loggedIn' && <Toolbar />}
      {children}
    </Box>
  );
};
